import React, { useRef, useState, useEffect } from "react";

const AboutTheBook = ({ titleTag: TitleTag = "h2" }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const handleVideoToggle = () => {
    const video = videoRef.current;
    if (!video) return;

    if (!video.getAttribute("src")) {
      video.src = "/Videos/Ghosted-Md.mp4";
    }

    video.muted = false;
    video.playsInline = true;

    if (video.paused) {
      video
        .play()
        .then(() => setIsPlaying(true))
        .catch((err) => console.error("Video play error:", err));
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".amazon_btn")) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // const buyLinks = [
  //   {
  //     name: "Amazon",
  //     link: "https://www.amazon.com/Ghosted-MD-Awakening-Nafsika-Antypas/dp/B0FJMJG9YK",
  //   },
  //   {
  //     name: "Barnes & Noble",
  //     link: "https://www.barnesandnoble.com/w/ghosted-md-nafsika-antypas/1148065257",
  //   },
  //   {
  //     name: "Indigo",
  //     link: "https://www.indigo.ca/en-ca/ghosted-mdthe-awakening/8736d5af-9ced-3012-aa21-38880e567fef.html",
  //   },
  //   {
  //     name: "Apple Books",
  //     link: "https://books.apple.com/ca/book/ghosted-md-the-awakening/id6758962054",
  //   },
  // ]
  const buyLinks = [
    {
      label: "Amazon",
      url: "https://www.amazon.com/Ghosted-MD-Awakening-Nafsika-Antypas/dp/B0FJMJG9YK",
    },
    {
      label: "Apple Books",
      url: "https://books.apple.com/ca/book/ghosted-md-the-awakening/id6758962054",
    },
    {
      label: "Barnes & Noble",
      url: "https://www.barnesandnoble.com/w/ghosted-md-nafsika-antypas/1148065257",
    },
    {
      label: "Indigo",
      url: "https://www.indigo.ca/products/ghosted-md-ghosted-md-1?variant=46713307267282",
    },
    {
      label: "Kobo",
      url: "https://www.kobo.com/in/en/ebook/ghosted-md-the-awakening-2?sId=ddc2e8ce-f05e-4a93-af38-0a1faa6b30a1&ssId=dPdQhCgPlUeY3RlOtPbgH&cPos=1",
    },
    {
      label: "Google Play Books",
      url: "https://www.google.co.in/books/edition/Ghosted_MD/AoDH0QEACAAJ?hl=en",
    },
    {
      label: "Bookshop.org",
      url: "https://bookshop.org/",
    },
    {
      label: "Goodreads",
      url: "https://www.goodreads.com",
    },
    {
      label: "Waterstones",
      url: "https://www.waterstones.com",
    },
  ];

  return (
    <section className="Custom_img_text_new amazon_md">
      <div className="page-width">
        <div className="Custom_img_text_new_wrapper">
          <div className="Custom_img_text_new_block">
            {/* 🎬 Left Column (Desktop Video) */}
            <div className="Custom_img_text_new_left_col">
              <div className="Custom_img_text_new_img_wrap">
                <div className="mp4_wrapper poster_wide">
                  <video
                    ref={videoRef}
                    className="custom_video"
                    onClick={handleVideoToggle}
                    loop
                    poster="/Images/video-poster-book.webp"
                    preload="none"
                    playsInline
                    width="800"
                    height="600"
                  ></video>

                  {!isPlaying && (
                    <button
                      className="play_pause_btn play"
                      aria-label="Play video"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleVideoToggle();
                      }}
                    >
                      ▶
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* 📖 Right Column */}
            <div className="Custom_img_text_new_right_col">
              <TitleTag className="Custom_img_text_new_title h1">
                About The <span>Book</span>
              </TitleTag>

              <div className="Custom_img_text_new_desc desc">
                <p>
                  <em>Ghosted MD</em> -{" "}
                  <strong>A Supernatural Medical Thriller</strong>
                  <br />
                  <strong>Now available as a novel by Nafsika Antypas</strong>
                </p>
              </div>

              <div className="Key_features_content_wrap">
                <div className="Key_features_desc desc">
                  <p>
                    <b>
                      When brilliant cardiologist Dr. Anastasia Dimas tries to
                      save a stranger named Jason Walker, she never expects him
                      to return—as a ghost.
                    </b>
                  </p>

                  <p>
                    Entwined with the spirit of the man whose life she fought to
                    save, Stacey is pulled into a chilling mystery that suggests
                    his death was no accident. As she navigates a perilous world
                    of crime, danger, and supernatural intrigue, she uncovers
                    secrets that blur the line between the living and the dead.
                  </p>

                  <p>
                    <b>Ghosted MD: The Awakening</b> blends suspense, romance,
                    and the supernatural into a gripping story you won’t forget.
                    Think Lucifer meets Ghost, and imagine what shenanigans may
                    follow. With fast-paced dialogue, genre-blending tension,
                    and a love story that transcends mortality, this debut novel
                    from Nafsika Antypas delivers thrills, laughs, and a
                    heartwarming core. It’s the first book in a series that
                    explores grief, justice, and the extraordinary bond between
                    two people caught between worlds.
                  </p>

                  {/* <p>
                    When brilliant cardiologist Dr. Anastasia Dimas tries to save a stranger
                    named Jason Walker, she never expects him to return—as a ghost. Drawn into a
                    chilling mystery, Stacey must uncover the truth behind Jason’s death while
                    navigating crime, danger, and a growing connection to the spirit world.
                  </p>
                  <p>
                    Ghosted MD blends suspense, romance, and the supernatural into a gripping
                    story you won’t forget.
                  </p> */}
                </div>
              </div>

              {/* 🛒 BUY NOW with Dropdown */}
              <div className="Custom_img_text_new_btn_wrap amazon_btn">
                <div className="amazon_btn_title desc">Get your copy now</div>

                <button
                  className="button main-buy-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowDropdown((prev) => !prev);
                  }}
                >
                  <img
                    src="https://cdn.shopify.com/s/files/1/0705/9406/8713/files/Frame_1000002438.png?v=1748867192"
                    width="30"
                    height="30"
                    alt="Icon"
                  />
                  BUY NOW
                </button>

                {showDropdown && (
                  <div className="buy-dropdown fade-in">
                    {buyLinks.map((link, index) => (
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        key={index}
                      >
                        {link.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTheBook;

// import React, { useRef, useState } from 'react';

// const AboutTheBook = () => {
//   const desktopVideoRef = useRef(null);
//   const mobileVideoRef = useRef(null);
//   const [isPlaying, setIsPlaying] = useState(false);

//   const handleVideoToggle = (target) => {
//     const video = target === 'desktop' ? desktopVideoRef.current : mobileVideoRef.current;
//     if (!video) return;

//     // Ensure proper inline playback behavior for iPhones
//     video.muted = false;
//     video.playsInline = true;

//     if (video.paused) {
//       video.play()
//         .then(() => setIsPlaying(true))
//         .catch(err => console.error('Video play error:', err));
//     } else {
//       video.pause();
//       setIsPlaying(false);
//     }
//   };

//   return (
//     <section className="Custom_img_text_new amazon_md">
//       <div className="page-width">
//         <div className="Custom_img_text_new_wrapper">
//           <div className="Custom_img_text_new_block">

//             {/* 🎬 Left Column (Desktop Video) */}
//             <div className="Custom_img_text_new_left_col">
//               <div className="Custom_img_text_new_img_wrap">
//                 <div className="mp4_wrapper">
//                   <video
//                     ref={desktopVideoRef}
//                     src="/Videos/Ghosted-Md.mp4"
//                     className="custom_video"
//                     onClick={() => handleVideoToggle('desktop')}
//                     loop
//                     poster="/Images/Video-banner.jpg"
//                     preload="metadata"
//                     playsInline
//                   ></video>

//                   {!isPlaying && (
//                     <button
//                       className="play_pause_btn play"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleVideoToggle('desktop');
//                       }}
//                     >
//                       ▶
//                     </button>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* 📖 Right Column */}
//             <div className="Custom_img_text_new_right_col">
//               <h2 className="Custom_img_text_new_title h1">
//                 About The <span>Book</span>
//               </h2>

//               {/* 🎥 Mobile Video */}
//               <div className="Custom_img_text_new_img_wrap only_mobile">
//                 <div className="mp4_wrapper">
//                   <video
//                     ref={mobileVideoRef}
//                     src="/Videos/Ghosted-Md.mp4"
//                     className="custom_video"
//                     onClick={() => handleVideoToggle('mobile')}
//                     loop
//                     poster="/Images/Video-banner.jpg"
//                     preload="metadata"
//                     playsInline
//                   ></video>

//                   {!isPlaying && (
//                     <button
//                       className="play_pause_btn play"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleVideoToggle('mobile');
//                       }}
//                     >
//                       ▶
//                     </button>
//                   )}
//                 </div>
//               </div>

//               <div className="Custom_img_text_new_desc desc">
//                 <p>
//                   <em>Ghosted MD</em> - <strong>A Supernatural Medical Thriller</strong>
//                   <br />
//                   <strong>Now available as a novel by Nafsika Antypas</strong>
//                 </p>
//               </div>

//               <div className="Key_features_content_wrap">
//                 <div className="Key_features_desc desc">
//                   <p>
//                     When brilliant cardiologist Dr. Anastasia Dimas tries to save a stranger
//                     named Jason Walker, she never expects him to return—as a ghost. Drawn into a
//                     chilling mystery, Stacey must uncover the truth behind Jason’s death while
//                     navigating crime, danger, and a growing connection to the spirit world.
//                   </p>
//                   <p>
//                     Ghosted MD blends suspense, romance, and the supernatural into a gripping
//                     story you won’t forget.
//                   </p>
//                 </div>
//               </div>

//               <div className="Custom_img_text_new_btn_wrap amazon_btn">
//                 <div className="amazon_btn_title desc">Get your copy now</div>
//                 <a href="https://www.amazon.com/Ghosted-MD-Awakening-Nafsika-Antypas/dp/B0FJMJG9YK" className="button">
//                   <img
//                     src="https://cdn.shopify.com/s/files/1/0705/9406/8713/files/Frame_1000002438.png?v=1748867192"
//                     width="30px"
//                     height="30px"
//                     alt="Icon"
//                   />
//                   BUY ON AMAZON
//                 </a>
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default AboutTheBook;
